import { Icon } from "@atoms";
import { Badge } from "@molecules";
import { Div } from "@quarks";
import { pxToRem } from "@utils";
import { useTheme } from "styled-components";
import { ScheduleDataIconsProps } from "./types";

export const ScheduleDataIcon = ({ status, icon, ...props }: ScheduleDataIconsProps) => {
  const theme = useTheme();

  return (
    <Div
      position="relative"
      {...props}>
      {status && (
        <Badge
          data-testid={`${props["data-testid"]}-Indicator`}
          badge={status}
          right="0"
          size="small"
          top="0"
        />
      )}
      <Icon
        icon={icon}
        size={pxToRem(20)}
        color={theme.icon.inactive}
      />
    </Div>
  );
};
